import { DEFAULT_PAGE_SIZE } from 'config/constants';
import { calculatePageSize } from 'helpers/loadMore/calculatePageSize';

export const hasReadAllProductsFromCache = (
    productsFromCacheLength: number | undefined,
    currentLoadMore: number,
    currentPage: number,
    totalProductCount: number | undefined,
    pageSize = DEFAULT_PAGE_SIZE,
) => {
    if (!totalProductCount) {
        return false;
    }

    const hasReadAllProductsFromCacheByTotalCount =
        totalProductCount - (currentPage - 1) * pageSize === productsFromCacheLength;
    const hasReadAllProductsFromCacheByLoadMore =
        productsFromCacheLength === calculatePageSize(currentLoadMore, pageSize);

    return hasReadAllProductsFromCacheByTotalCount || hasReadAllProductsFromCacheByLoadMore;
};
